import React from "react";
import { Quote, Star } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { TID } from "@/constants/testIds/dv";

export const Testimonials = () => {
  const { t } = useLanguage();
  const items = t("testimonials.items");
  const list = Array.isArray(items) ? items : [];

  return (
    <section
      id="testimonials"
      data-testid={TID.testimonialsSection}
      className="bg-background py-24 md:py-32 border-t border-border"
    >
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-10 bg-[#E63946]" />
              <span className="label-eyebrow">{t("testimonials.eyebrow")}</span>
            </div>
            <h2 className="font-display uppercase text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight">
              {t("testimonials.title")}
            </h2>
          </div>
          <p className="md:max-w-md text-muted-foreground text-base leading-relaxed">
            {t("testimonials.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {list.map((item, i) => (
            <article
              key={i}
              data-testid={TID.testimonialCard(i)}
              className={`group relative border p-6 md:p-7 rounded-sm flex flex-col gap-5 hover:-translate-y-1 transition-all duration-300 ${
                i === 0
                  ? "bg-black text-white border-black hover:border-[#E63946] md:col-span-2"
                  : "bg-white text-foreground border-border hover:border-[#E63946]"
              }`}
            >
              <Quote className="h-7 w-7 text-[#E63946]" strokeWidth={1.5} />
              <p
                className={`leading-relaxed font-medium ${
                  i === 0 ? "text-white text-lg md:text-xl" : "text-foreground text-base"
                }`}
              >
                &ldquo;{item.quote}&rdquo;
              </p>
              <div
                className={`mt-auto pt-4 border-t ${
                  i === 0 ? "border-white/15" : "border-border/60"
                }`}
              >
                <div className="flex items-center gap-1 mb-2">
                  {[...Array(5)].map((_, k) => (
                    <Star
                      key={k}
                      className="h-3.5 w-3.5 fill-[#E63946] text-[#E63946]"
                      strokeWidth={0}
                    />
                  ))}
                </div>
                <div
                  className={`font-display uppercase tracking-tight text-lg ${
                    i === 0 ? "text-white" : "text-foreground"
                  }`}
                >
                  {item.name}
                </div>
                <div
                  className={`text-xs uppercase tracking-[0.2em] mt-0.5 ${
                    i === 0 ? "text-white/60" : "text-muted-foreground"
                  }`}
                >
                  {item.role} · {item.city}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
